import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';

import { PurchaseMethodsModel } from 'commons-vehicle/PurchaseMethods/index.js';
import ModelYear from 'commons-vehicle/ModelYear/index.js';

import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';
import AmountLineItemWithIcon from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx';

class ProtectionsListing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showProtectionsDetails: false,
        };

        this.showProtectionsDetails = this.showProtectionsDetails.bind(this);
    }

    showProtectionsDetails() {
        this.setState((prevState) => {
            return { showProtectionsDetails: !prevState.showProtectionsDetails };
        });
    }

    render() {
        const { protectionsPackages, purchaseMethodLabels, purchaseMethods } = this.props;
        const totalProtectionsAmount = purchaseMethods.getProtectionsAmount(protectionsPackages);
        const protectionsRenderBlock = protectionsPackages.map((protectionPackage) => {
            const label = protectionPackage.label || protectionPackage.description;
            const description =
                protectionPackage.label && protectionPackage.description ? ` (${protectionPackage.description})` : '';
            return <AmountLineItemWithIcon label={`${label}${description}`} amount={protectionPackage.retail} />;
        });

        return (
            <div className="SidebarSummary__protectionsDetails">
                <div className="SidebarSummary__groupTitle">
                    <h3 className="sr-title SidebarSummary__groupTitle--title">
                        {LocaleService.t('SUMMARY.SUMMARY_PROTECTIONS_TITLE', { finance: purchaseMethodLabels.name })}
                        {!this.state.showProtectionsDetails && (
                            <span className="SidebarSummary__groupTitle--subtitle">
                                {LocaleService.t('SUMMARY.SELECTED_PROTECTIONS_AMOUNT', {
                                    amount: protectionsPackages.length,
                                })}
                            </span>
                        )}
                    </h3>
                    {protectionsPackages.length > 0 && (
                        <span className="chevron" role="button" tabIndex={0} onClick={this.showProtectionsDetails}>
                            <icon
                                className={
                                    this.state.showProtectionsDetails
                                        ? 'icon-chevron-thin-down inverted'
                                        : 'icon-chevron-thin-down'
                                }
                            />
                        </span>
                    )}
                </div>
                <ReactCollapse isOpened={this.state.showProtectionsDetails}>
                    <ul className="protectionsListing">{protectionsRenderBlock}</ul>
                </ReactCollapse>
                <span className="total">
                    <AmountLineItem label={LocaleService.t('SUMMARY.TOTAL')} amount={totalProtectionsAmount} />
                </span>
            </div>
        );
    }
}

ProtectionsListing.defaultProps = {
    purchaseMethodLabels: [],
    protectionsPackages: [],
};

ProtectionsListing.propTypes = {
    purchaseMethodLabels: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }),
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsModel),
    protectionsPackages: PropTypes.arrayOf(
        PropTypes.shape({
            items: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.OptionModel)),
            itemsPackage: PropTypes.instanceOf(ModelYear.OptionModel),
            payment: PropTypes.number.isRequired,
            paymentTaxes: PropTypes.number.isRequired,
            retail: PropTypes.number.isRequired,
            taxes: PropTypes.number.isRequired,
        })
    ),
};

ProtectionsListing.displayName = 'ProtectionsListing';

export default ProtectionsListing;
